export default "__VITE_ASSET__7721acbc__"